import { media } from 'breakpoints';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

const verticalCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LayoutMainContainer = styled.div`
  ${verticalCenter}
  justify-content: center;
  height: 100%;
`;

export const LayoutCardContainer = styled.div`
  ${verticalCenter}
  background-color: ${colorPalette.white};
  border-radius: ${getSpacing(2)};
  margin: ${getSpacing(2)} 0;
  width: 800px;
  overflow-y: auto;
  ${media.md`
    width: 80%;
  `}
  ${media.xs`
    width: 90%;
  `}
`;

export const LayoutCardContentContainer = styled.div`
  width: 100%;
  ${verticalCenter}
  padding: ${getSpacing(4)};
  padding-top: 0;
  overflow-y: auto;
  ${media.xs`
    padding: 24px;
    padding-top: 0;
  `}
`;

export const LayoutCardHeaderContainer = styled.div`
  width: 100%;
  ${verticalCenter}
  padding: ${getSpacing(4)};
  ${media.xs`
    padding: 24px;
  `}
`;

export const LayoutBackgroundImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
`;

export const LayoutBackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  position: fixed;
  left: 0;
  overflow: hidden;
  top: 0;
`;

export const HeaderBrandLink = styled(Link)`
  font-size: 0;
`;

export const HeaderBrandImage = styled.img`
  height: 100%;
  width: 100%;
  max-width: 130px;
  object-fit: contain;
`;

export const HeaderTitle = styled.h3`
  flex-grow: 1;
  ${typography.title_small};
  font-size: ${getSpacing(2.5)};
  text-align: start;
`;
